const STORAGE_PREFIX = 'mp_';

function prefixedKey(key: string): string {
  return `${STORAGE_PREFIX}${key}`;
}

function safeGet<T>(key: string): T | null {
  try {
    const raw = localStorage.getItem(prefixedKey(key));
    if (raw === null) return null;
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
}

function safeSet(key: string, value: unknown): void {
  try {
    localStorage.setItem(prefixedKey(key), JSON.stringify(value));
  } catch {
  }
}

function safeRemove(key: string): void {
  try {
    localStorage.removeItem(prefixedKey(key));
  } catch {
  }
}

export const StorageKeys = {
  BALANCE: 'balance',
  PROFILE: 'profile',
  AUDIO_PREFS: 'audio_prefs',
  CRASH_HISTORY: 'crash_history',
  BET_HISTORY: 'bet_history',
  SLOT_PREFS: (slotId: number) => `slot_${slotId}_prefs`,
  STREAMER_JOINED: (id: string) => `streamer_joined_${id}`,
  STREAMER_JOIN_DISMISSED: (id: string) => `streamer_join_dismissed_${id}`,
} as const;

export const StorageService = {
  get: safeGet,
  set: safeSet,
  remove: safeRemove,

  getOrDefault<T>(key: string, defaultValue: T): T {
    const stored = safeGet<T>(key);
    return stored !== null ? stored : defaultValue;
  },

  appendToList<T>(key: string, item: T, maxItems: number): T[] {
    const list = safeGet<T[]>(key) ?? [];
    list.unshift(item);
    if (list.length > maxItems) list.length = maxItems;
    safeSet(key, list);
    return list;
  },

  getList<T>(key: string, limit?: number): T[] {
    const list = safeGet<T[]>(key) ?? [];
    return limit ? list.slice(0, limit) : list;
  },
};
